import React from 'react';
import SearchResultList from './SearchResultList';
import Card from '../Card/Card';
import LoadingCard from '../LoadingCard';
import Notification from '../Notification';

const NotifyCard = ({ children }) => (
  <Card className="text-center horizontal-padding">
    { children }
  </Card>
);

const NoDocumentsFound = () => (
  <NotifyCard>
    <Notification type="info" data-name="not-found"> No documents found matching your search</Notification>
  </NotifyCard>
);

const SearchError = ({ message }) => (
  <NotifyCard>
    <Notification type="error" data-name="error">{ message }</Notification>
  </NotifyCard>
);

export default function SearchResultBody({
  items,
  query,
  currentPage,
}) {
  if (!items) {
    return (
      <LoadingCard
        text="Loading papers"
        data-name="loading"
        fullHeight
      />
    );
  }

  if (items.error) {
    return (
      <SearchError
        message={items.message || 'Error loading search results'}
      />
    );
  }

  if (!items.length) {
    return (
      <NoDocumentsFound />
    );
  }

  return (
    <SearchResultList
      items={items}
      query={query}
      currentPage={currentPage}
    />
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResults/SearchResultBody.js